import {CM_FWU_TARGET_TYPES} from '../../consts/communicationLayer/cmFwuTargetTypes';
import {FWU_ERROR_CODES} from '../../consts/fwu/fwuErrorCodes';
import fwuPackageTypes from '../../consts/fwu/fwuPackageTypes';
import {FWU_TARGET_TYPES} from '../../consts/fwu/fwuTargetTypes';
import fwuService from '../fwu/fwuService';
import cmMessageRequestService from './cmMessageRequestService';

const onSuccessPackageLoad = ({isHolder, message}) => {
    const {token, request_id} = message;

    cmMessageRequestService.publishFwuPackageLoadedEvent(request_id, token, isHolder);
};

const onFwuError = ({errorCode, message, isHolder}) => {
    // const state = getState();
    // const isOfflineMode = makeSelectIsOfflineYapFirmwareInProgress()(state);
    // if (isOfflineMode) {
    //     dispatch(setFWUError());
    //     dispatch(setYapLastRequestId(null, isHolder));
    //     dispatch(setYapFirmwareInProgress(false));
    //     return;
    // }

    const {type, token, request_id} = message;
    cmMessageRequestService.publishFwuErrorEvent({
        type,
        request_id,
        token,
        isHolder,
        errorCode,
    });
};

const getIsEngineFromMessage = (message) => {
    const {data} = message;
    const {target} = data || {};
    const isEngine = target === CM_FWU_TARGET_TYPES.ENGINE;

    return isEngine;
};

const getFwuTargetFromMessage = (message, isHolder) => {
    const isEngine = getIsEngineFromMessage(message);
    const isBleStack = fwuPackageTypes.isBleStack(message?.data?.package_type);

    if (isHolder) {
        return isEngine ? FWU_TARGET_TYPES.HOLDER_ENGINE : FWU_TARGET_TYPES.HOLDER_DEVICE;
    }

    if (isBleStack) {
        return FWU_TARGET_TYPES.BLE_STACK;
    }

    return isEngine ? FWU_TARGET_TYPES.MONO_ENGINE : FWU_TARGET_TYPES.CHARGER_OR_MONO;
};

// Check if we need this
// const storeFirmwareDataToMwState = (message, isHolder) => {
//     const {data} = message;
//     const isEngine = getIsEngineFromMessage(message);

//     let fwuData;

//     if (isHolder) {
//         fwuData = isEngine ? {[DEVICE_TARGET_NAMES.HOLDER_ENGINE]: data} : {[DEVICE_TARGET_NAMES.HOLDER]: data};
//     } else {
//         const isBleStack = fwuPackageTypes.isBleStack(data?.package_type);

//         if (isBleStack) {
//             fwuData = {[DEVICE_TARGET_NAMES.BLE_STACK]: data};
//         } else {
//             fwuData = isEngine ? {[DEVICE_TARGET_NAMES.DEVICE_ENGINE]: data} : {[DEVICE_TARGET_NAMES.DEVICE]: data};
//         }
//     }

//     return data;

//     // TODO: add to state
//     // dispatch(setMwDeviceFirmwareData(fwData));
// };

const onFirmwareUpdatePackageLoadHandler = async (message, isHolder) => {
    const {data} = message;
    fwuService.clearPackageData();

    const fwuTarget = getFwuTargetFromMessage(message, isHolder);

    try {
        await fwuService.downloadFwuPackage({
            fwuTarget,
            downloadUrl: data?.download_url,
        });

        onSuccessPackageLoad({isHolder, message});
    } catch (error) {
        onFwuError({
            errorCode: error?.code,
            message,
            isHolder,
        });
    }

    // const isSblFirmware = fwuPackageTypes.isSbl(message.data.package_type);

    // TODO: IA
    // appRouterService.forwardToUpdateFWPage({
    //     target: fwu_target,
    //     version: data.version,
    //     isSblFirmware,
    // });
};

const onFirmwareUpdateStartHandler = async (message, isHolder) => {
    const {type, token, request_id} = message;
    const onFwuStatusEvent = (n) => {
        cmMessageRequestService.publishFwuStatusEvent(type, request_id, token, n, isHolder);
    };
    const onFwuFinish = (isHolder) => {
        // TODO: VR check pls
        // dispatch(setCmMessageData(token, request_id));
        cmMessageRequestService.publishFwuFinishEvent(type, request_id, token, isHolder);
    };
    // TODO: VR check pls
    // const isConnected = await cmService.waitUntilConnected({isHolder, isCheckDeviceReady: true});
    const isConnected = true;

    if (isConnected) {
        const fwuTarget = getFwuTargetFromMessage(message, isHolder);

        fwuService.startFwUpdate({
            fwuTarget,
            onFwuError: (params) => onFwuError(params, message, isHolder),
            onFwuStatusEvent,
            onFwuFinish,
        });
    } else {
        onFwuError({errorCode: FWU_ERROR_CODES.GENERAL, message, isHolder});
    }
};

const getFwuReconnectTimeout = () => {
    // const isFirmwareTargetBleStack = selectIsFirmwareTargetBleStack(getState());
    // const isFirmwareCompleted = selectIsFirmwareCompleted(getState());
    // const result =
    //     cmTimeouts.CM_FWU_CONNECT_TIMEOUT +
    //     (isFirmwareTargetBleStack && isFirmwareCompleted ? BLE_STACK_FWU_RECONNECT_POPUP_DELAY_MS / 100 : 0);
    // return result;
};

export default {
    onFirmwareUpdatePackageLoadHandler,
    onFirmwareUpdateStartHandler,
};
